<template>
  <div class="series-page container">
    <div class="columns is-marginless">
      <div class="column is-three-fifths">
        <star-series :series="currentSeries"></star-series>
        <h1>{{ currentSeries.pagetitle }}</h1>
        <div v-html="currentSeries.content" class="video-content"></div>
      </div>
      <div class="column is-two-fifths has-text-centered">
        <!-- <star-video :video="video"></star-video> -->
        <!-- <p>אורך: {{video.videoDuration}} דקות</p> -->
        <teacher-imglink
          v-for="(teacher, index) in teachers"
          :teacher="teacher"
          :key="index"
        ></teacher-imglink>
      </div>
    </div>
    <current-video
      :video="fullVideo"
      :initialData="initialData"
      :len="seriesLength"
      :pos="seriesPosition"
      v-if="seriesPosition !== 0"
      v-on:load-next="loadNextVideo"
      :isLast="isLast"
      :nextSeries="nextSeries"
      v-on:update-history="updateHistory()"
    ></current-video>

    <div class="more-videos">
      <h2>כל השיעורים בתוכנית</h2>
      <series-videolist
        :videos="currentSeriesVideoList"
        :sid="$route.params.sid"
        :currentVideo="`${fullVideo.id}`"
        v-on:change-video="changeVideo"
      ></series-videolist>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import TeacherImglink from "@/components/teachers/TeacherImglink.vue";
import CurrentVideo from "@/components/series/CurrentVideo.vue";
import SeriesVideolist from "@/components/series/SeriesVideolist.vue";
import StarSeries from "@/components/series//StarSeries.vue";

export default {
  name: `SeriesPage`,

  components: {
    TeacherImglink,
    CurrentVideo,
    SeriesVideolist,
    StarSeries,
  },

  data() {
    return {
      fullVideo: { id: 0 },
    };
  },

  methods: {
    getTeacher(tid) {
      if (Array.isArray(this.$store.state.initialData.teachers)) {
        const arr = this.$store.state.initialData.teachers.filter(t => {
          if (`${t.id}` === `${tid}`) {
            return true;
          }
          return false;
        });

        return arr[0];
      }
      return { pagetitle: ``, content: `` };
    },

    getSeries() {
      if (this.$store.state.series.length > 0) {
        const arr = this.$store.state.series.filter(item => {
          if (item.id === this.$route.params.sid) {
            return true;
          }
          return false;
        });

        return arr[0];
      }
      return {};
    },

    checkHistory(sid) {
      if (Array.isArray(this.$store.state.user.seriesHistory)) {
        const arr = this.$store.state.user.seriesHistory.filter(series => {
          if (`${series.id}` === `${sid}`) {
            return true;
          }
          return false;
        });

        if (arr.length > 0) {
          const histArray = arr[0].watched.split(`,`);
          const lastWatchedId = histArray[histArray.length - 1];
          const v = this.currentSeries.videoItems.split(`||`);
          const i = v.indexOf(`${lastWatchedId}`);
          if (typeof v[i + 1] === `undefined`) {
            return v[i];
          }
          return v[i + 1];
        }
      }
      return 0;
    },

    getVideoId(vid) {
      if (vid === 0) {
        return this.currentSeriesVideoList[0].id;
      }
      // eslint-disable-next-line
      const arr = this.currentSeriesVideoList.filter(
        v => `${v.id}` === `${vid}`
      );
      console.log(vid + "-" + this.currentSeriesVideoList);
      if (arr.length > 0) {
        console.log("test");
        return `${arr[0].id}`;
      }
      return this.currentSeries.videoItems.split(`||`)[0];
    },

    changeVideo(id) {
      axios
        .get(`${process.env.VUE_APP_API_VIDEOLIST}`, {
          params: { vid: `${id}` },
        })
        .then(res => {
          this.fullVideo = res.data[0];
          window.scrollTo(0, 100);
        });
    },

    loadNextVideo() {
      this.changeVideo(this.currentSeriesVideoList[this.seriesPosition].id);
    },
    updateHistory() {
      const done = this.fullVideo.id;
      const sid = this.$route.params.sid;
      this.$store.dispatch(`addToSeriesHistory`, { sid, done });
    },
  },

  computed: {
    initialData() {
      return this.$store.state.initialData;
    },

    currentSeries() {
      if (this.$store.state.series.length > 0) {
        const arr = this.$store.state.series.filter(item => {
          if (item.id === this.$route.params.sid) {
            return true;
          }
          return false;
        });

        return arr[0];
      }
      return { pagetitle: ``, content: ``, id: `` };
    },
    currentSeriesVideoList() {
      const sorted = [];
      if (Array.isArray(this.currentSeries.videoList)) {
        const sortOrder = this.currentSeries.videoItems.split(`||`);
        this.currentSeries.videoList.forEach(item => {
          const index = sortOrder.indexOf(`${item.id}`);
          sorted[index] = item;
        });
      }
      return sorted;
    },

    teachers() {
      const output = [];
      const uniqList = [];
      if (Array.isArray(this.currentSeries.videoList)) {
        this.currentSeries.videoList.forEach(item => {
          if (!uniqList.includes(item.videoTeacher)) {
            uniqList.push(item.videoTeacher);
            output.push(this.getTeacher(item.videoTeacher));
          }
        });
      }
      return output;
    },

    seriesLength() {
      if (Array.isArray(this.currentSeries.videoList)) {
        return this.currentSeries.videoList.length;
      }
      return 0;
    },
    seriesPosition() {
      if (typeof this.currentSeries.videoItems !== `undefined`) {
        const arr = this.currentSeries.videoItems.split(`||`);
        return arr.indexOf(`${this.fullVideo.id}`) + 1;
      }
      return 1;
    },

    isLast() {
      if (this.seriesPosition === this.seriesLength) {
        return true;
      }
      return false;
    },

    isLoggedIn() {
      return this.$store.state.user.isLoggedIn;
    },
    seriesHistoryData() {
      return this.$store.state.user.seriesHistory;
    },
    nextSeries() {
      if (this.currentSeries.nextSeries.length > 0) {
        return parseInt(this.currentSeries.nextSeries, 10);
      }
      return 0;
    },
  },

  watch: {
    currentSeriesVideoList() {
      const lastWatched = this.checkHistory(`${this.currentSeries.id}`);
      const videoId = this.getVideoId(lastWatched);
      axios
        .get(`${process.env.VUE_APP_API_VIDEOLIST}`, {
          params: { vid: `${videoId}` },
        })
        .then(res => {
          this.fullVideo = res.data[0];
        });
    },
  },

  created() {
    // if (this.isLoggedIn === 0) {
    //   this.$router.push(`/profile`);
    // }

    const series = this.getSeries();
    if (typeof series.id !== `undefined`) {
      const lastWatched = this.checkHistory(`${series.id}`);
      const videoId = this.getVideoId(lastWatched);
      axios
        .get(`${process.env.VUE_APP_API_VIDEOLIST}`, {
          params: { vid: `${videoId}` },
        })
        .then(res => {
          this.fullVideo = res.data[0];
        });
    }
  },
};
</script>

<style lang="scss">
.more-videos {
  padding-top: 30px;
  padding-right: 15px;
  h2 {
    font-size: 24px;
    margin: 20px -15px 30px 0;
  }
  .video-item {
    margin: 0 0 15px 15px;
  }
}
</style>
